//import { Container } from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  const loginBackHandler = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "calc(100vw)",
        fallbacks: [
          "-moz-calc(100vw)",
          "-webkit-calc(100vw)",
          "-o-calc(100vw)",
        ],
        overflow: "auto",
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        flexDirection: "column",
      }}
    >
      <h2 style={{ width: "auto" }}>
        You Have Been Logged Out <br /> Thank you for using our website
      </h2>
      <h4 style={{ width: "auto" }}>
        Please click &nbsp;
        <a href="#" onClick={loginBackHandler}>
          here
        </a>
        &nbsp; to login back to our site
      </h4>
    </Box>
  );
};

export default Logout;
